import styled from 'styled-components'
import { SPACING } from '../../design/spacing/spacing.constants'

const RowCardWrapper = styled.section`
  display: flex;
  margin: 0 0 ${SPACING.M};

  &:last-of-type {
    margin-bottom: 0;
  }
`

RowCardWrapper.displayName = 'RowCardWrapper'

export { RowCardWrapper }
